import { EnvironmentLabelMapping } from 'app/types/types'
import { EnvironmentEnum } from './client-constants'

export const isDevelopmentEnvironment = (environment: string = ''): boolean =>
  environment === EnvironmentEnum.DEVELOPMENT || environment === EnvironmentEnum.TEST_LOCAL

export const isProductionEnvironment = (environment: string = ''): boolean => environment === EnvironmentEnum.PROD_EU

export const getEnvironmentLabel = (environment: EnvironmentEnum | string = EnvironmentEnum.DEVELOPMENT): string => {
  const envLabel = environmentLabelMap.find((envMap: EnvironmentLabelMapping) => envMap.key === environment)?.label
  return envLabel || 'Development'
}
export const environmentLabelMap: EnvironmentLabelMapping[] = [
  {
    key: EnvironmentEnum.DEVELOPMENT,
    label: 'Development'
  },
  {
    key: EnvironmentEnum.PRE_EU,
    label: 'Pre Production'
  },
  {
    key: EnvironmentEnum.QA_QA,
    label: 'QA'
  },
  {
    key: EnvironmentEnum.QA_MQA,
    label: 'MQA'
  },
  {
    key: EnvironmentEnum.QA_QA1,
    label: 'QA1'
  },
  {
    key: EnvironmentEnum.QA_QA2,
    label: 'QA2'
  },
  {
    key: EnvironmentEnum.TEST_LOCAL,
    label: 'Test Local'
  },
  {
    key: EnvironmentEnum.DEMO_QA,
    label: 'Demo QA'
  },
  {
    key: EnvironmentEnum.DEMO_MQA,
    label: 'Demo MQA'
  },
  {
    key: EnvironmentEnum.DEMO_QA1,
    label: 'Demo QA1'
  },
  {
    key: EnvironmentEnum.DEMO_QA2,
    label: 'Demo QA2'
  },
  {
    key: EnvironmentEnum.DEMO_QA2_V2,
    label: 'Demo QA2 V2'
  },
  {
    key: EnvironmentEnum.QA_QA2_V2,
    label: 'QA2 V2'
  }
]
